export const amenities_rates = {
  1073742786: {
    label: "Colazione",
    icon: "breakfast"
  },
  1073742857: {
    label: "Colazione",
    icon: "breakfast"
  },
  1073744459: {
    label: "Colazione",
    icon: "breakfast"
  },
  2103: {
    label: "Colazione",
    icon: "breakfast"
  },
  2104: {
    label: "Colazione",
    icon: "breakfast"
  },
  2105: {
    label: "Colazione",
    icon: "breakfast"
  },
  2193: {
    label: "Colazione",
    icon: "breakfast"
  },
  2194: {
    label: "Colazione",
    icon: "breakfast"
  },
  2205: {
    label: "Colazione",
    icon: "breakfast"
  },
  2106: {
    label: "Pasti",
    icon: "check_circle"
  },
  2107: {
    label: "Pasti",
    icon: "check_circle"
  },
  2108: {
    label: "Pasti",
    icon: "check_circle"
  },
  2203: {
    label: "Pasti",
    icon: "check_circle"
  },
  2102: {
    label: "Pensione completa",
    icon: "check_circle"
  },
  2207: {
    label: "Pensione completa",
    icon: "check_circle"
  },
  2206: {
    label: "Mezza pensione",
    icon: "check_circle"
  },
  2111: {
    label: "All inclusive",
    icon: "check_circle"
  },
  1073742787: {
    label: "Internet",
    icon: "check_circle"
  },
  2191: {
    label: "Internet",
    icon: "check_circle"
  },
  2192: {
    label: "Internet",
    icon: "check_circle"
  },
  2109: {
    label: "Parcheggio",
    icon: "check_circle"
  },
  2110: {
    label: "Parcheggio",
    icon: "check_circle"
  },
  2195: {
    label: "Parcheggio",
    icon: "check_circle"
  },
  1073742618: {
    label: "Spa e benessere",
    icon: "check_circle"
  },
  1073743286: {
    label: "Spa e benessere",
    icon: "check_circle"
  },
  2200: {
    label: "Spa e benessere",
    icon: "check_circle"
  },
  1073742617: {
    label: "Sci ed esperienze",
    icon: "check_circle"
  },
  1073742861: {
    label: "Sci ed esperienze",
    icon: "check_circle"
  },
  1073742862: {
    label: "Sci ed esperienze",
    icon: "check_circle"
  },
  1073742863: {
    label: "Sci ed esperienze",
    icon: "check_circle"
  },
  1073743288: {
    label: "Sci ed esperienze",
    icon: "check_circle"
  },
  2204: {
    label: "Sci ed esperienze",
    icon: "check_circle"
  },
  1073742858: {
    label: "Golf pass",
    icon: "check_circle"
  },
  2201: {
    label: "Golf pass",
    icon: "check_circle"
  },
  1073742551: {
    label: "Drink gratuito di benvenuto",
    icon: "check_circle"
  }
}

export function get_amenities_rates(key) {
  const amenity = amenities_rates[key]
  if (amenity !== undefined) return amenity
  return { label: key, icon: "check_circle", }
}